'use client'
import { ReactNode, useContext } from 'react'

import { appTrace } from '~/utils'
import { UserRole } from '~/generated/graphql'

import { IdentityContext } from '../context'
import { WaitForStableAuthState } from './WaitForStableAuthState'
import { useNavigation } from './NavigationContext'

function EnforceAdminInner({
  children,
  redirect = true,
}: {
  redirect?: boolean
  children: ReactNode
}) {
  const { currentUser } = useContext(IdentityContext)
  const navigation = useNavigation()

  if (currentUser?.role !== UserRole.Admin) {
    appTrace(`EnforceAdmin: not an admin (role: ${currentUser?.role}), redirecting to /`)
    if (redirect) {
      navigation.navigate({
        name: 'enforce_admin_redirect',
        route: '/',
      })
    }
    return null
  }
  return children
}

export function EnforceAdmin({ children }: { children: ReactNode }) {
  return (
    <WaitForStableAuthState>
      <EnforceAdminInner redirect={true}>{children}</EnforceAdminInner>
    </WaitForStableAuthState>
  )
}

export function AdminOnly({ children }: { children: ReactNode }) {
  return (
    <WaitForStableAuthState>
      <EnforceAdminInner redirect={false}>{children}</EnforceAdminInner>
    </WaitForStableAuthState>
  )
}
